"use strict";
// @ts-ignore
try {
    self['workbox:routing:6.4.1'] && _();
}
catch (e) { }
